import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text, Button } from "@ui-component-library";

import MailIcon from "@assets/icons/mail.svg";
import PhoneIcon from "@assets/icons/phone.svg";
import ChatIcon from "@assets/icons/chat.svg";
import SpeakerIcon from "@assets/icons/speaker.svg";
import PressIcon from "@assets/icons/press.svg";
import ArrowRightIcon from "@assets/icons/arrow-right.svg";

const Card = (data) => {
  const props = data.props;

  return (
    <div className="flex flex-col gap-6 p-6 bg-white rounded-[20px] border border-1 border-solid border-[#E6E6E6]">
      <div className="flex flex-col items-center justify-center rounded-[11px] bg-[#E9FF8F] w-11 h-11">
        {props.icon}
      </div>

      <div>
        <Text variant="text-base/leading-normal/medium" className="text-[#1A1A1A]">{props.title}</Text>
        <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">{props.desc}</Text>
      </div>

      {props.openingHours && <div>
        <Text variant="text-sm/leading-normal/medium" className="text-[#0F0F0F]">Öppettider</Text>
        <Text variant="text-sm/leading-normal/normal" className="text-[#737373]">{props.openingHours}</Text>
      </div>}

      {props.action && props.action.text && <Text variant="text-base/leading-normal/medium" className="text-[#1A1A1A] cursor-pointer" onClick={() => window.location.href = props.action.link}>{props.action.text}</Text>}

      {props.action && props.action.button && <Button variant="secondary" className="text-start justify-between" onClick={() => window.location.href = props.action.link}>{props.action.button} <ArrowRightIcon width={22} height={22} fill="#0F0F0F" /></Button>}
    </div>
  );
};

const ContactUsSection = (props) => {  
  return (
    <TailwindWrapper>
      <div className="bg-[#F6F5F4]">
        <section className='container py-24'>
          <Text variant="text-sm/leading-normal/medium" className="text-[#737373]">Kontakta oss</Text>

          <Text variant="text-4xl/leading-normal/medium" className="text-[#0F0F0F] my-5">{props.title}</Text>

          <Text variant="text-base/leading-normal/normal" className="text-[#737373] mb-12">{props.description}</Text>

          <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-3">
            <Card props={{title: "Chatt", desc: "Få svar på dina frågor direkt.", openingHours: "Mån-Fre. 08:00 - 17:00", icon: <ChatIcon width={22} height={22} fill="#0F0F0F" />}} />

            <Card props={{title: "Telefon", desc: "Prata med en av våra rådgivare.", openingHours: "Mån-Fre. 08:00 - 17:00", icon: <PhoneIcon width={22} height={22} fill="#0F0F0F" />, action: {text: "08 - 33 99 44", link: "tel:00468339944", button: "Ring oss"}}} />

            <Card props={{title: "Mejl", desc: "Vi svarar inom 1–2 arbetsdagar.", openingHours: "24/7", icon: <MailIcon width={22} height={22} fill="#0F0F0F" />, action: {text: "information@treebula.se", link: "mailto:information@treebula.se", button: "Skriv till oss"}}} />
          </div>
        </section>
      </div>
      
      <div className="bg-[#FDFDFD]">
        <section className="container my-24">
          <Text variant="text-4xl/leading-normal/medium" className="text-[#0F0F0F] mb-12">Press & samarbete</Text>

          <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-3">
            <Card props={{title: "Marknad", desc: "För samarbeten och partnerskap.", action: {link: "mailto:marketing@treebula.se", button: "marketing@treebula.se"}, icon: <SpeakerIcon width={22} height={22} fill="#0F0F0F" />}} />

            <Card props={{title: "Press", desc: "För pressfrågor och intervjuer.", action: {link: "mailto:press@treebula.se", button: "press@treebula.se"}, icon: <PressIcon width={22} height={22} fill="#0F0F0F" />}} />
          </div>
        </section>
      </div>
    </TailwindWrapper>
  );
};

ContactUsSection.defaultProps = {
    title: "Personlig service från riktiga människor",
    description: "Vi finns här när du behöver oss — välj det sätt som passar dig bäst.",
  };
  
ContactUsSection.fields = {
  title: {
      type: "text",
      label: "Section title",
  },
  description: {
    type: "text",
    label: "Description text",
  },
};  

export default ContactUsSection;
